import { CountryCode } from 'root-constants/common'

export const getIsUSAUser = (countryCode: string) => {
  return countryCode === CountryCode.UNITED_STATES.toUpperCase()
}
